import { render } from "./EmployeesList.vue?vue&type=template&id=17e89bb6"
import script from "./EmployeesList.vue?vue&type=script&lang=js"
export * from "./EmployeesList.vue?vue&type=script&lang=js"

import exportComponent from "/Users/fci/Downloads/traininGulftic-main/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__